/*global google*/
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import mapStyles from './mapStyle';

import redMapMarker from "../../images/place_order/red-map-marker.png";

const DEFAULT_CENTER = { lat: 3.0640394, lng: 101.60916369999995 };
const DEFAULT_ZOOM = 14;

export const Map = withGoogleMap(props => {
  return (
      <GoogleMap
          defaultZoom={DEFAULT_ZOOM}
          defaultCenter={DEFAULT_CENTER}
          {...(props.center ? { center: props.center, zoom: props.zoom || DEFAULT_ZOOM } : {})}
          options={{ gestureHandling: "greedy", styles: mapStyles }}
      >
        {
          props.marker &&
          <Marker
            position={props.marker}
            icon={{
              url: redMapMarker,
              scaledSize: new google.maps.Size(35, 50),
            }}
          />
        }
      </GoogleMap>
  );
});
